import React from 'react';

import useCDNUrl from '../hooks/useCDNUrl.js';


export default function RIQPageError({children}) {

    const sadGraphsUrl = useCDNUrl('/images/sad_graphs.png');

    function onContactUsClick() {
        if (window.Intercom) {
            window.Intercom('show');
        }
    }

    return (
        <div className='tlw-mb-10 tlw-mt-15 tlw-flex tlw-flex-col tlw-items-center'>
            <img
                className='tlw-m-auto tlw-w-2/5'
                alt='error'
                src={sadGraphsUrl}
            />
            <div className='tlw-mt-10 tlw-text-center tlw-text-lg'>

                {children}

                {!children &&
                    <>
                        <p>
                            Sorry! An unexpected error has occurred.
                        </p>
                        <p
                            className='tlw-text-md'
                        >
                            You can try reloading this page or, if you need any assistance, please&nbsp;
                            <button
                                className='tlw-border-0 tlw-bg-transparent tlw-p-0 tlw-text-md tlw-font-medium tlw-leading-20 tlw-text-blue-400 tlw-outline-none'
                                onClick={onContactUsClick}
                            >
                                contact us
                            </button>
                            &nbsp;and we&apos;ll get right back to you.
                        </p>
                    </>
                }
            </div>
        </div>
    );
}
